import type { resumeClientData } from "~/interfaces"

export const resumeMapping = {
    credit: (data: resumeClientData) => {
        return data.Importo ?? null
    },
    piano_f: (data: resumeClientData) => {
        return data.PianoF ?? null
    },
    rate: (data: resumeClientData) => {
        return data.Rate ?? null
    },
    fido: (data: resumeClientData) => {
        return data.Fido ?? null;
    },
    isRevolving: (data: resumeClientData) => {
        // use the presence of Fido to determine if the selected credit is revolving
        return !!data.Fido
    },
    StampaContratto: (data: resumeClientData) => {
        return data.StampaContratto ?? null
    },
    privacy1: (data: resumeClientData) => {
        return data.privacy1 === 'S' ? true : false
    },
    privacyWa: (data: resumeClientData) => {
        return data.privacy2 === 'S' ? true : false
    },
    privacy2: (data: resumeClientData) => {
        return data.privacyWa === 'S' ? true : false
    },
    privacy3: (data: resumeClientData) => {
        return data.privacy4 === 'S' ? true : false
    },
    privacy4: (data: resumeClientData) => {
        return data.privacy3 === 'S' ? true : false
    },
    taxCode: (data: resumeClientData) => {
        return data.CF ?? null
    },
    email: (data: resumeClientData) => {
        return data.EMail ?? null
    },
    cellphone: (data: resumeClientData) => {
        return data.Phone ? `+39 ${data.Phone}` : null
    },
    name: (data: resumeClientData) => {
        return data.Nome ?? null
    },
    surname: (data: resumeClientData) => {
        return data.Cognome ?? null
    },
    maritalStatus: (data: resumeClientData) => {
        if (data.Stato_Civile === null || data.Stato_Civile === undefined)
            return null
        return +data.Stato_Civile + 1;
    },
    citizenship: (data: resumeClientData) => {
        return data.Cittadinanza ?? null
    },
    stayFrom: (data: resumeClientData) => {
        // date format MM/yyyy
        return data.Permesso_Dal ?? null
    },
    stayTo: (data: resumeClientData) => {
        // date format dd/MM/yyyy
        return data.Permesso_End ?? null
    }, 
    financialProblems: (data: resumeClientData) => {
        if (data.Disguidi_Finanziari === null || data.Disguidi_Finanziari === undefined)
            return null
        return data.Disguidi_Finanziari 
    },
    loanProjectType: (data: resumeClientData) => {
        return data.Dest ?? null
    },
    employmentType: (data: resumeClientData) => {
        switch (data.Attivita) {
            // if Attivita == 0, is LIB PROF or LAV AUTONOMO
            // -> if Settore == 5, is LIB PROF, else is LAV AUTONOMO
            case 0: 
                if (data.Settore === 5)  return EMPLOYMENT_TYPES.PROFESSIONISTA
                else  return EMPLOYMENT_TYPES.AUTONOMO
            // if Attivita == 1, is DIP DET -> return 2
            case 1:
                return EMPLOYMENT_TYPES.DIPENDENTE;
            // if Attivita == 2, is STAGIONALE -> return 3
            case 2:
                return EMPLOYMENT_TYPES.STAGIONALE;
            // if Attivita == 3, if Settore == 0, rely on Occupazione
            case 3:
                if (data.Settore === 0 && data.Occupazione !== null && data.Occupazione !== undefined) {
                    return +data.Occupazione + 4
                } else {
                    return null
                }
            default:
                return null
        }
    },
    employmentSector: (data: resumeClientData) => {
        if (data.Attivita === null || data.Settore === null || data.Settore === undefined)
            return null;
        // case CASAL, DISOCC, PENSION, PENS INVAL, REDD, STUD
        if (data.Attivita === 3 && data.Settore === 0)
            return 0
        // all other cases
        return +data.Settore + 1;
    },
    occupation: (data: resumeClientData) => {
        if (data.Attivita === null || data.Settore === null || data.Occupazione === null || data.Occupazione === undefined)
            return null;
        // case CASAL, DISOCC, PENSION, PENS INVAL, REDD, STUD
        if (data.Attivita === 3 && data.Settore === 0)
            return 0
        // case LIB PROF
        if (data.Attivita === 0 && data.Settore === 5)
            return +data.Settore + 1
        // all other cases
        return +data.Occupazione + 1
        
    },
    hiringType: (data: resumeClientData) => {
        if (data.Contratto === null || data.Contratto === undefined)
            return null;
        return +data.Contratto + 1
    },
    monthlyPayment: (data: resumeClientData) => {
        if (data.Attivita === null || data.Attivita === undefined || data.Mensilita === null || data.Mensilita === undefined)
            return null;

        // DIP DET
        if (data.Attivita === 1)
            return +data.Mensilita + 1;

        // PENSIONATO & PENSIONATO invalid
        if (data.Attivita === 3 && (data.Occupazione === 2 || data.Occupazione === 3))
            return +data.Mensilita + 1;

        // all other cases dont have mensilita
        return null
    },
    monthlyIncome: (data: resumeClientData) => {
        if (data.Reddito === null || data.Reddito === undefined || data.Reddito === 1)
            return null
        return data.Reddito
    },
    employedSince: (data: resumeClientData) => {
        // date format MM/yyyy
        if (data.Occupato_Dal === null || data.Occupato_Dal === undefined)
            return null;
        return data.Occupato_Dal
    },
    employedTo: (data: resumeClientData) => {
        // date format MM/yyyy
        if (data.Occupato_Al === null || data.Occupato_Al === undefined)
            return null;
        return data.Occupato_Al
    },
    familyMemberCount: (data: resumeClientData) => {
        if (data.Famigliari === null || data.Famigliari === undefined)
            return null
        return data.Famigliari + 1
    },
    employedFamilyMemberCount: (data: resumeClientData) => {
        if (data.Famigliari_Reddito === null || data.Famigliari_Reddito === undefined)
            return null
        return data.Famigliari_Reddito + 1
    },
    employerName: (data: resumeClientData) => {
        return data.Datore ?? null
    },
    employerAddress: (data: resumeClientData) => {
        return data.Datore_Indirizzo ?? null
    },
    employerStreetNumber: (data: resumeClientData) => {
        return data.Datore_N ?? null
    },
    employerPostalCode: (data: resumeClientData) => {
        return data.Datore_CAP ?? null
    },
    employerCity: (data: resumeClientData) => {
        return data.Datore_Comune ?? null
    },
    employerPhone: (data: resumeClientData) => {
        return data.Datore_Phone ? `+39 ${data.Datore_Phone}` : null
    },
    familyIncome: (data: resumeClientData) => {
        if (data.Reddito_Dimostrabile === null || data.Reddito_Dimostrabile === undefined)
            return null
        return !!data.Reddito_Dimostrabile
    },
    familyIncomeActivity: (data: resumeClientData) => {
        if (data.Attivita_Parent === null || data.Attivita_Parent === undefined)
            return null
        return +data.Attivita_Parent
    },
    housingType: (data: resumeClientData) => {
        if (data.Abitazione === null || data.Abitazione === undefined)
            return null
        return +data.Abitazione + 1
    },
    monthlyRent: (data: resumeClientData) => {
        return data.Affitto ?? null
    },
    residenceSince: (data: resumeClientData) => {
        return data.Abitazione_Dal ?? null
    },
    address: (data: resumeClientData) => {
        return data.Indirizzo ?? null
    },
    addressNumber: (data: resumeClientData) => {
        return data.N ?? null
    },
    addressCap: (data: resumeClientData) => {
        return data.CAP ?? null
    },
    addressCity: (data: resumeClientData) => {
        return data.Comune ?? null
    },
    sameAddresses: (data: resumeClientData) => {
        if (data.Domicilio === null || data.Domicilio === undefined)
            return true
        return !!(data.Domicilio + 1)
    },
    address2: (data: resumeClientData) => {
        return data.Indirizzo_Dom ?? null
    },
    addressNumber2: (data: resumeClientData) => {
        return data.N_Dom ?? null
    },
    addressCap2: (data: resumeClientData) => {
        return data.CAP_Dom ?? null
    },
    addressCity2: (data: resumeClientData) => {
        return data.Comune_Dom ?? null
    },
    identityType: (data: resumeClientData) => {
        if (data.Doc_Type === null || data.Doc_Type === undefined)
            return null
        return +data.Doc_Type
    },
    documentNumber: (data: resumeClientData) => {
        return data.Doc_Number ?? null
    },
    documentCity: (data: resumeClientData) => {
        return data.Doc_Comune ?? null
    },
    documentRelease: (data: resumeClientData) => {
        // date format dd/MM/yyyy
        if (!data.Doc_Data_Day || !data.Doc_Data_Month || !data.Doc_Data_Year)
            return null;
        return `${data.Doc_Data_Day}/${data.Doc_Data_Month}/${data.Doc_Data_Year}`
    },
    documentExpire: (data: resumeClientData) => {
        // date format dd/MM/yyyy
        if (!data.Doc_Data_End_Day || !data.Doc_Data_End_Month || !data.Doc_Data_End_Year)
            return null;
        return `${data.Doc_Data_End_Day}/${data.Doc_Data_End_Month}/${data.Doc_Data_End_Year}`
    },
    insurancePack: (data: resumeClientData) => {
        return data.assicurazione_pack ?? null
    },
    insurance: (data: resumeClientData) => {
        if (data.assicurazione === null || data.assicurazione === undefined)
            return null;
        return !!data.assicurazione
    },
    servicePack: (data: resumeClientData) => {
        return data.service_pack ?? null;
    },
    service: (data: resumeClientData) => {
        return !!data.service
    },
    servicePackCyber: (data: resumeClientData) => {
        return data.service_pack_cyber ?? null
    },
    serviceCyber: (data: resumeClientData) => {
        return !!data.service_cyber
    },
    installmentDebitDay: (data: resumeClientData) => {
        if (data.Scadenza_Day === null || data.Scadenza_Day === undefined)
            return null;
        return data.Scadenza_Day + 1;
    },
    iban: (data: resumeClientData) => {
        return data.Iban ?? null;
    },

}